import { render, staticRenderFns } from "./alerts-current-report.vue?vue&type=template&id=2136aa4a&scoped=true"
import script from "./alerts-current-report.vue?vue&type=script&lang=js"
export * from "./alerts-current-report.vue?vue&type=script&lang=js"
import style0 from "./alerts-current-report.vue?vue&type=style&index=0&id=2136aa4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2136aa4a",
  null
  
)

export default component.exports